"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabPanelMenu = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var tab_panel_menu_items_desktop_1 = require("./items/desktop/tab-panel-menu-items-desktop");
var tab_panel_menu_style_1 = require("./tab-panel-menu-style");
var tab_panel_menu_type_1 = require("./tab-panel-menu-type");
var tab_panel_menu_items_mobile_1 = require("./items/mobile/tab-panel-menu-items-mobile");
function TabPanelMenu(props) {
    var _a = props.tabItemMinWidth, tabItemMinWidth = _a === void 0 ? '80px' : _a, _b = props.tabItemSize, tabItemSize = _b === void 0 ? tab_panel_menu_type_1.TabItemSize.WITH_MIN_WIDTH : _b, restProps = __rest(props, ["tabItemMinWidth", "tabItemSize"]);
    return ((0, jsx_runtime_1.jsxs)(tab_panel_menu_style_1.StyledTabPanel, { tabItemSize: tabItemSize, tabItemMinWidth: tabItemMinWidth, children: [(0, jsx_runtime_1.jsx)(tab_panel_menu_items_desktop_1.TabPanelMenuItemsDesktop, __assign({}, restProps)), (0, jsx_runtime_1.jsx)(tab_panel_menu_items_mobile_1.TabPanelMenuItemsMobile, __assign({}, restProps))] }));
}
exports.TabPanelMenu = TabPanelMenu;
